import React from "react";
import { useState, useEffect } from 'react';
import apiClient from '../../services/apiClient';
import { useNavigate } from 'react-router-dom'; 
import { Await } from "react-router-dom/dist/umd/react-router-dom.development";
import { Link } from "react-router-dom";

export default function DashboardHome() {

  const [events, setEvents] = useState([]);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  const [subscription, setSubscription] = useState(null);
 const [loadingSubscription, setLoadingSubscription] = useState(true);


  
  useEffect(() => {
        // Get user ID from localStorage
        const udata = localStorage.getItem('user');
        if (udata) {
            try {
                const user_data = JSON.parse(udata);
                if (user_data?.user?.id) {
                    setUserId(user_data.user.id);
                }
            } catch (e) {
                console.error('Error parsing user data:', e);
            }
        }
        // Note: Auth redirect is handled by ProtectedRoute, not here
    }, []);

  useEffect(() => {
  const fetchEvents = async () => {
    if (userId) {
      try {
        const response = await apiClient.get(`/events-list/${userId}`);
        
        if (response.data.success === true) {
          const allEvents = response.data.events;

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const filteredAndLabeledEvents = allEvents
            .map(event => {
              const eventDate = new Date(event.date); // date = "2025-08-26"
              eventDate.setHours(0, 0, 0, 0);

              const diffInDays = (eventDate - today) / (1000 * 60 * 60 * 24);

              let label = "";
              if (diffInDays === 0) label = "Today";
              else if (diffInDays === 1) label = "Tomorrow";
              else if (diffInDays === 2) label = "Day after Tomorrow";
              else label = `${diffInDays} Days after today`;

              return { ...event, diffInDays, label };
            })
            .filter(event => event.diffInDays >= 0 && event.diffInDays <= 4); // show only within 4 days

          setEvents(filteredAndLabeledEvents);
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    }
  };

  fetchEvents();
}, [userId]);


 const [tasks, setTasks] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);

  // 🔹 Load tasks from localStorage (and clear if next day)
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("todoTasks")) || [];
    const savedDate = localStorage.getItem("todoDate");
    const today = new Date().toDateString();

    // If date changed → clear tasks
    if (savedDate !== today) {
      localStorage.removeItem("todoTasks");
      localStorage.setItem("todoDate", today);
      setTasks([]);
    } else {
      setTasks(saved);
    }
  }, []);

  // 🔹 Save tasks whenever they change
  useEffect(() => {
    localStorage.setItem("todoTasks", JSON.stringify(tasks));
    localStorage.setItem("todoDate", new Date().toDateString());
  }, [tasks]);

  // 🔹 Auto add task after brief pause
  useEffect(() => {
    if (inputValue.trim() === "") return;

    if (typingTimeout) clearTimeout(typingTimeout);
    const timeout = setTimeout(() => {
      setTasks((prev) => [
        ...prev,
        { text: inputValue.trim(), completed: false },
      ]);
      setInputValue("");
    }, 700);
    setTypingTimeout(timeout);

    return () => clearTimeout(timeout);
  }, [inputValue]);

  // 🔹 Toggle completion
  const toggleTask = (index) => {
    setTasks((prev) => {
      const updated = [...prev];
      updated[index].completed = !updated[index].completed;
      return updated;
    });
  };

  // 🔹 Organize tasks
  const doneTasks = tasks.filter((t) => t.completed);
  const pendingTasks = tasks.filter((t) => !t.completed);
  const nextTask = pendingTasks[0];

  // 🔹 Format time
  const now = new Date();
  const dateLabel = now.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
  });
  const timeLabel = now.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const getToken = () => {
  const data = localStorage.getItem("user");
  if (!data) return null;
  return JSON.parse(data).access_token;
};

  useEffect(() => {
  const fetchSubscription = async () => {
    try {
      const token = getToken();
      if (!token) return;

      const res = await apiClient.get(
        `/subscription/status`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSubscription(res.data);
    } catch (err) {
      console.error("Subscription fetch failed", err);
    } finally {
      setLoadingSubscription(false);
    }
  };

  fetchSubscription();
}, []);


const handleSubscribe = async () => {
  try {
    const token = getToken();
    if (!token) return;

    const res = await apiClient.post(
      `/billing/checkout`, // ✅ correct route
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    window.location.href = res.data.url;
  } catch (err) {
    console.error("Checkout error", err);
  }
};


const handleBilling = async () => {
  try {
    const token = getToken();
    if (!token) return;

    const res = await apiClient.post(
      `/stripe/billing-portal`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    window.location.href = res.data.url;
  } catch (err) {
    console.error("Billing portal error", err);
  }
};


const ALLOWED = ["active", "trialing"];
const SOFT_WARN = ["past_due", "incomplete"];
const HARD_BLOCK = ["canceled", "unpaid", "expired"];



  return (
    <>
      <div className="col-sm-12 col-md-12 col-xl-5 box-wrap-main">
      <div className="h-100 bg-white rounded p-4 shadow box-wrap">
        {/* Header */}
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h6 className="mb-0">
            To Do List - DONE ({doneTasks.length}) - {dateLabel} @ {timeLabel}
          </h6>
        </div>

        {/* Next Task */}
        {nextTask && (
          <div className="alert alert-info py-2 mb-3">
            <strong>Next Task:</strong> {nextTask.text}
          </div>
        )}

        {/* Input */}
        <div className="d-flex mb-2 px-lg-3 px-0">
          <input
            className="form-control bg-transparent"
            type="text"
            placeholder="What needs to be done?"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </div>

        {/* DONE Tasks */}
        {doneTasks.map((task, i) => (
          <div
            key={`done-${i}`}
            className="d-flex align-items-center py-2 px-lg-3 px-0"
          >
            <input
              className="form-check-input m-0"
              type="checkbox"
              checked={task.completed}
              onChange={() => toggleTask(tasks.indexOf(task))}
            />
            <div className="w-100 ms-3">
              <span
                style={{
                  textDecoration: "line-through",
                  color: "gray",
                  opacity: 0.7,
                }}
              >
                {task.text}
              </span>
            </div>
          </div>
        ))}

        {/* Pending Tasks */}
        {pendingTasks.map((task, i) => (
          <div
            key={`pending-${i}`}
            className="d-flex align-items-center py-2 px-lg-3 px-0"
          >
            <input
              className="form-check-input m-0"
              type="checkbox"
              checked={task.completed}
              onChange={() => toggleTask(tasks.indexOf(task))}
            />
            <div className="w-100 ms-3">
              <span>{task.text}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
       
      <div className='col-sm-12 col-md-12 col-xl-5'>
        <div className='h-100 bg-white rounded p-4 shadow box-wrap' id=''>
          <div className='d-flex align-items-center justify-content-between mb-4'>
            <h6 className='mb-0'>Upcoming Events</h6>
          </div>
          <table className='table table-borderless'>
            <thead>
              <tr>
                <th scope='col'>Event Date:</th>
                <th scope='col'>Event Name:</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event, i) => (
                
                <tr key={i}>
                  <td>
                  {(() => {
                    const d = new Date(event.date);
                    const formattedDate = d.toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                    });
                    const dayName = d.toLocaleDateString("en-IN", { weekday: "long" });
                    return (
                      <>
                        {formattedDate}
                        <br />
                        <small style={{ color: "gray", textAlign: "center", justifyContent: "center" }}>{dayName}</small>
                      </>
                    );
                  })()}
                  </td>
                  <td>
                    <Link to={`/customer-events/${event.id}`} state={{ event }} key={i}>
                     {event.name}
                    </Link>
                    <span style={{ marginLeft: "8px", color: "gray" }}>
                      ({event.label})
                    </span>
                  </td>
                </tr>
              ))}

            </tbody>
          </table>

        

        </div> 
      </div>

       {!loadingSubscription && subscription && (
            <div className="alert alert-warning mt-4">

              {subscription.status === "trialing" && (
                <>
                  <strong>Trial active.</strong>
                  <br />
                  Ends in {subscription.trial_days_left} days.
                  <br />
                  <button
                    className="btn btn-primary mt-2"
                    onClick={handleSubscribe}
                  >
                    Subscribe Now
                  </button>
                </>
              )}

              {subscription.status === "expired" && (
                <>
                  <strong>Trial expired.</strong>
                  <br />
                  <button
                    className="btn btn-danger mt-2"
                    onClick={handleSubscribe}
                  >
                    Add Payment Method
                  </button>
                </>
              )}

              {subscription.status === "active" && (
                <>
                  <strong>Subscription Active.</strong>
                  <br />
                  <button
                    className="btn btn-secondary mt-2"
                    onClick={handleBilling}
                  >
                    Manage Billing
                  </button>
                </>
              )}



              {subscription?.status === "past_due" && (
                <div className="alert alert-warning mt-4">
                  <strong>Payment issue.</strong>
                  <br />
                  Please update your payment method.
                  <br />
                  <button
                    className="btn btn-outline-warning mt-2"
                    onClick={handleBilling}
                  >
                    Update Payment
                  </button>
                </div>
              )}


              {!loadingSubscription &&
                  subscription &&
                  HARD_BLOCK.includes(subscription.status) ||
                  (subscription.status === 'trialing' && new Date(subscription.current_period_end) < new Date()) && (
                    <div
                      style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        className="bg-white rounded p-4 shadow"
                        style={{
                          maxWidth: "420px",
                          width: "90%",
                          textAlign: "center",
                        }}
                      >
                        <h4 className="mb-3">Subscription Required</h4>

                        <p className="text-muted">
                          Your subscription is inactive.
                          Please add a payment method to continue.
                        </p>

                        <button
                          className="btn btn-danger w-100 mt-3"
                          onClick={handleSubscribe}
                        >
                          Add Payment Method
                        </button>
                          <Link to="/logout" className="text-dark">
                                            Logout
                          </Link>
                      </div>
                    </div>
                )}


            </div>
          )}

          


    </>
  );
}
